import request from '/src/api/request.js'
// 查询钉钉历史记录
export function selectDingHistorical(query) {
    return request({
        url: '/api/sys/dingHistoricalApproval/GetDingHistorical',
        method: 'POST',
        data:query,
    })
}